import {createSlice} from '@reduxjs/toolkit';

const INIT_STATE = {
    // Global states
    currentContextType: null,

    // Action Panel
    actionPanelPosition: {x: 0, y: 0},
    actionPanelOpen: false,
    actionPanelNearEdge: false,
    actionPanelPinned: 'none',
    actionPanelPinnedSize: 'normal',
    actionPanelDisableComponent: [],

    // Smart Search
    smartSearchOpen: false,
};

export const globalModalSlice = createSlice({
    name: 'globalModal',
    initialState: INIT_STATE,
    reducers: {
        setCurrentContextType: (state, payload) => {
            state.currentContextType = payload.payload;
        },

        setActionPanelPosition: (state, payload) => {
            state.actionPanelPosition = payload.payload;
        },
        setActionPanelNearEdge: (state, payload) => {
            state.actionPanelNearEdge = payload.payload;
        },
        setActionPanelOpen: (state, payload) => {
            state.actionPanelOpen = payload.payload;
        },
        setActionPanelPinned: (state, payload) => {
            state.actionPanelPinned = payload.payload;
        },
        setActionPanelPinnedSize: (state, payload) => {
            state.actionPanelPinnedSize = payload.payload;
        },
        setActionPanelDisableComponent: (state, payload) => {
            state.actionPanelDisableComponent = payload.payload;
        },


        setSmartSearchOpen: (state, payload) => {
            state.smartSearchOpen = payload.payload;
        },
    },
});

// Setters
export const {
    setCurrentContextType,
    setActionPanelPosition,
    setActionPanelNearEdge,
    setActionPanelOpen,
    setActionPanelPinned,
    setActionPanelPinnedSize,
    setActionPanelDisableComponent,
    setSmartSearchOpen,
} = globalModalSlice.actions;

// Variable
export const globalCurrentContextType = state => state.globalModal.currentContextType;
export const globalActionPanelPosition = state => state.globalModal.actionPanelPosition;
export const globalActionPanelNearEdge = state => state.globalModal.actionPanelNearEdge;
export const globalActionPanelOpen = state => state.globalModal.actionPanelOpen;
export const globalActionPanelPinned = state => state.globalModal.actionPanelPinned;
export const globalActionPanelPinnedSize = state => state.globalModal.actionPanelPinnedSize;
export const globalActionPanelDisableComponent = state => state.globalModal.actionPanelDisableComponent;
export const globalSmartSearchOpen = state => state.globalModal.smartSearchOpen;

// Functions
export const closeAllActionPanel = () => (dispatch, getState) => {
    dispatch(setActionPanelOpen(false));
    dispatch(setActionPanelNearEdge(false));
    dispatch(setActionPanelPinned('none'));
    dispatch(setActionPanelPinnedSize('normal'));
};

export default globalModalSlice.reducer;
